/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function RoleReader({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.155 2.831a2.543 2.543 0 0 0-4.808.776L.405 10.67a.6.6 0 0 0 0 .151A4 4 0 0 0 .4 11c0 1.972 1.559 3.6 3.517 3.6s3.516-1.628 3.516-3.6q-.001-.504-.13-.97c.16-.138.41-.23.697-.23.288 0 .538.092.697.23q-.129.466-.13.97c0 1.972 1.559 3.6 3.517 3.6S15.6 12.972 15.6 11q0-.09-.005-.181a.6.6 0 0 0-.001-.148l-.942-7.064a2.543 2.543 0 0 0-4.808-.776l-.051.107a.6.6 0 0 0 1.079.524l.052-.106a1.343 1.343 0 0 1 2.538.41l.565 4.233a3.44 3.44 0 0 0-1.944-.599c-1.194 0-2.24.605-2.874 1.525A2.35 2.35 0 0 0 8 8.6c-.408 0-.84.1-1.21.325A3.48 3.48 0 0 0 3.917 7.4c-.722 0-1.39.221-1.945.6l.565-4.235a1.343 1.343 0 0 1 2.538-.41l.052.107a.6.6 0 1 0 1.08-.524zM3.917 8.6C2.653 8.6 1.6 9.658 1.6 11s1.053 2.4 2.317 2.4c1.263 0 2.316-1.058 2.316-2.4S5.18 8.6 3.917 8.6m8.167 0c-1.264 0-2.317 1.058-2.317 2.4s1.053 2.4 2.317 2.4S14.4 12.342 14.4 11s-1.053-2.4-2.317-2.4" clipRule="evenodd" /></svg>;
}
;